const state = {
    lockStepper: false,
};

const getters = {
    isStepperLocked: state => state.lockStepper,
};

const actions = {
    lockStepper({commit}, lockStepper){
        commit('LOCKSTEPPER', lockStepper);
    },

};

const mutations = {
    LOCKSTEPPER(state, lockStepper){
        state.lockStepper = lockStepper;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}
